export default __webpack_public_path__ + "static/media/linkedinWhite.d63215bf.svg";